import React from 'react';
import { UpArrow } from '../icons/Icons';

const PageOne = (props) => {
  return (
    <div className="kids-quiz__page">

      <div id="gender" className="kids-quiz__question">
        <p className="question__title">Are you...</p>
        <div className="answers-row--flex gender-question">
          {props.renderGenderAnswers}
        </div>
      </div>

      <a href="#age" className={`question-divider ${props.gender ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="age" className={`kids-quiz__question ${props.gender ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <label className="question__title">How old are you?</label>
        <input onChange={props.onChangeNumber} onBlur={props.checkAge} value={props.age} pattern="\d*"></input>
      </div>

      {props.ageWarningMessage()}

      <a href="#race" className={`question-divider ${props.suitableAge && props.age ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="race" className={`kids-quiz__question ${props.suitableAge && props.age ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <p className="question__title">Would you consider yourself to be...</p>
        <div className="answers-row--flex race-question">
          {props.renderRaceAnswers}
        </div>
      </div>

      <div className={`next-page ${props.race ? 'next-page--show' : 'next-page--hidden'}`} onClick={() => props.nextPage('1')}>Continue</div>
    </div>
  );
}

export default PageOne;